module.exports = __webpack_public_path__ + "img/Slice10.d785819d.png";